/**
 * Analytics — Phase 1 stub (chỉ console.log).
 * Phase 2+ sẽ wire PostHog SDK + forward backend.
 *
 * Whitelist 5 events Phase 1 theo Phụ lục E.
 */

type EventName =
  | "app_opened"
  | "shop_name_created"
  | "first_order_completed"
  | "first_upgrade_purchased"
  | "session_ended";

export function track(event: EventName, props?: Record<string, unknown>): void {
  // Phase 1: chỉ log console — dễ debug dev. Phase 2+ replace bằng PostHog.
  console.info(`[analytics] ${event}`, props ?? {});
}
